import { c as _c } from "react/compiler-runtime";
import { Button } from '@/shared/components/ui';
import { useAvancoDoRelogio } from '../hooks/useAvancoDoRelogio';
import { UNIDADES_DE_AVANCO } from '../utils/avancoDoRelogio';
import { relogioDoTeste } from '../utils/rotulosDaSimulacao';
const ROTULO_DA_UNIDADE = {
  MINUTOS: 'Minutos',
  HORAS: 'Horas',
  DIAS: 'Dias'
} as const;

/** Bloco "Avançar tempo do teste" do #1333, ligado ao relógio virtual do core (CA-15). */
export const SimulacaoAvancoDoRelogio = () => {
  const $ = _c(42);
  const {
    quantidade,
    unidade,
    alterarQuantidade,
    alterarUnidade,
    started,
    ativa,
    relogioVirtualEm,
    mensagemDeValidacao,
    podeAvancar,
    avancando,
    pendentes,
    erro,
    avancar,
    continuar
  } = useAvancoDoRelogio();
  const restamVencimentos = pendentes > 0 && !avancando;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h3 className="text-heading-3 font-heading-3 text-default-font">Avançar tempo do teste</h3>;
    t1 = <p className="text-body text-subtext-color mt-1">Use para testar esperas, templates e expiração de sessão.</p>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const t2 = !ativa;
  const t3 = mensagemDeValidacao !== null;
  const t4 = mensagemDeValidacao ? "avanco-quantidade-erro" : undefined;
  let t5;
  if ($[2] !== alterarQuantidade) {
    t5 = event => alterarQuantidade(event.target.value);
    $[2] = alterarQuantidade;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== quantidade || $[5] !== t2 || $[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = <label className="text-caption-bold font-caption-bold text-default-font flex min-w-0 flex-1 flex-col gap-1.5">Quantidade<input type="number" min="1" step="1" inputMode="numeric" value={quantidade} disabled={t2} aria-invalid={t3} aria-describedby={t4} onChange={t5} className="focus:border-brand-500 focus:ring-brand-500/10 text-body text-default-font h-10 w-full rounded-[8px] border border-solid border-neutral-200 bg-white px-3 shadow-sm focus:ring-4 focus:outline-none disabled:opacity-60" /></label>;
    $[4] = quantidade;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = !ativa;
  let t8;
  if ($[10] !== alterarUnidade) {
    t8 = event_0 => alterarUnidade(event_0.target.value);
    $[10] = alterarUnidade;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = UNIDADES_DE_AVANCO.map(_temp);
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t7 || $[14] !== t8 || $[15] !== unidade) {
    t10 = <label className="text-caption-bold font-caption-bold text-default-font flex min-w-0 flex-1 flex-col gap-1.5">Unidade<select value={unidade} disabled={t7} onChange={t8} className="focus:border-brand-500 focus:ring-brand-500/10 text-body text-default-font h-10 w-full rounded-[8px] border border-solid border-neutral-200 bg-white px-3 shadow-sm focus:ring-4 focus:outline-none disabled:opacity-60">{t9}</select></label>;
    $[13] = t7;
    $[14] = t8;
    $[15] = unidade;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t6) {
    t11 = <div className="mt-4 flex items-end gap-2">{t6}{t10}</div>;
    $[17] = t10;
    $[18] = t6;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== mensagemDeValidacao) {
    t12 = mensagemDeValidacao && <p id="avanco-quantidade-erro" className="text-caption text-error-600 mt-2">{mensagemDeValidacao}</p>;
    $[20] = mensagemDeValidacao;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const t13 = !podeAvancar;
  let t14;
  if ($[22] !== avancar || $[23] !== t13) {
    t14 = <Button variant="neutral-secondary" className="mt-3 w-full justify-center" disabled={t13} onClick={avancar}>Avançar tempo</Button>;
    $[22] = avancar;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== relogioVirtualEm || $[26] !== started) {
    t15 = started && relogioVirtualEm && <p className="text-caption text-subtext-color mt-2">Relógio do teste: {relogioDoTeste(relogioVirtualEm)}</p>;
    $[25] = relogioVirtualEm;
    $[26] = started;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== erro) {
    t16 = erro && <p role="alert" className="text-caption text-error-600 mt-2">{erro.mensagem}</p>;
    $[28] = erro;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== ativa || $[31] !== continuar || $[32] !== pendentes || $[33] !== restamVencimentos) {
    t17 = restamVencimentos && <div className="mt-2 flex flex-wrap items-center gap-2"><p role="status" className="text-caption text-subtext-color">{pendentes === 1 ? "Ainda h\xE1 1 evento agendado para processar." : `Ainda há ${pendentes} eventos agendados para processar.`}</p><Button variant="neutral-secondary" size="small" disabled={!ativa} onClick={continuar}>Tentar novamente</Button></div>;
    $[30] = ativa;
    $[31] = continuar;
    $[32] = pendentes;
    $[33] = restamVencimentos;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t11 || $[36] !== t12 || $[37] !== t14 || $[38] !== t15 || $[39] !== t16 || $[40] !== t17) {
    t18 = <div className="mt-6 border-t border-solid border-neutral-200 pt-6">{t0}{t1}{t11}{t12}{t14}{t15}{t16}{t17}</div>;
    $[35] = t11;
    $[36] = t12;
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  return t18;
};
function _temp(opcao) {
  return <option key={opcao} value={opcao}>{ROTULO_DA_UNIDADE[opcao]}</option>;
}